import { mapState, mapGetters, mapActions } from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'ServiceDeliveryTerm',
  components: {
    Loading
  },
  metaInfo () {
    let title = this.categoryName + '管理 | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  props: {
    serviceId: String
  },
  data () {
    return {
      loading: true,
      processing: false,
      
      // テーブルオプション
      tableColumns: [
        'deliveryTypeId',
        'deliveryTypeName',
        'deliveryType',
        'deliveryPriority',
        'deliveryTypeStatus',
        'detailButton'
      ],
      tableData: [],
      tableOptions: {
        headings: {
          deliveryTypeId: '配信タイプID',
          deliveryTypeName: '配信タイプ名',
          deliveryType: '配信タイプ',
          deliveryPriority: '優先度',
          deliveryTypeStatus: 'ステータス',
          detailButton: ''
        },
        columnsClasses: {
          deliveryTypeId: 'wp-5',
          deliveryTypeName: '',
          deliveryType: '',
          deliveryPriority: '',
          deliveryTypeStatus: '',
          detailButton: 'wp-5 has-button'
        },
        sortable: [
          'deliveryTypeId',
          'deliveryTypeName',
          'deliveryType',
          'deliveryPriority',
          'deliveryTypeStatus'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts('配信タイプ'),
        // perPage: Constants.TableOptions.perPage.view,
        perPage: Constants.TablePerPageInitial,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial
    }
  },
  // beforeMount () {
  //   if (this.getPermission('Member')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    // this.$set(this.tableOptions, 'texts', Constants.TableOptions.getTexts(this.categoryName))

    this.init()
  },
  computed: {
    ...mapState({
      categoryName: state => state.serviceDeliveryTerm.categoryName,
      serviceName: state => state.serviceDeliveryTerm.serviceName,
      deliveryTypeModel: state => state.serviceDeliveryTerm.deliveryTypeModel,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept,
      
      // modal
      updatedList: state => state.serviceRegistDeliveryTypeModal.updated
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      permittedView: 'permission/permittedView',
      isSmartPhone: 'core/isSmartPhone'
    }),

    // list
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },
  },
  watch: {
    updatedList: function (to) {
      // モーダルで対象配信タイプの変更がされたら一覧を更新
      this.init()
    },
    // confirmAccepted: function (to) {
    //   console.log('confirmKey : ', this.confirmKey)
    //   // 登録
    //   if (this.confirmKey === 'modify') {
    //     if (to) this.postData()
    //   }
    // }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'serviceDeliveryTerm/loadModel',
      showServiceRegistDeliveryTypeModal: 'serviceRegistDeliveryTypeModal/show'
    }),

    init () {
      this.loading = true

      //
      let deliveryTypeParams = {
        serviceUuid: this.serviceId
      }

      // データ読出し
      this.loadModel({
        deliveryTypeParams: deliveryTypeParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.deliveryTypeModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      switch (key) {
        case 'deliveryPriority':
          return Utility.getConstantsLabel(['Mst', 'DeliveryPriorityKbn'], Number(value))
        case 'deliveryTypeStatus':
          return Utility.getConstantsLabel(['Status'], value)
      }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    // 絞り込み
    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },
    
    showDeliveryTypeSelector () {
      this.showServiceRegistDeliveryTypeModal(this.serviceId)
    },

    detailItem (props) {
      this.$router.push({
        name: 'ServiceDeliveryTermDetail',
        params: {
          serviceId: this.serviceId,
          deliveryTypeId: String(props.row.serviceDeliveryTypeUuid)
        }
      })
    }
  }
}